import React from 'react';

const Media = ({ resource }) => {
  const isVideo = typeof resource !== 'string' && resource?.mimeType?.includes('video');

  const { width, height, filename, alt } = resource;

  return (
    <>
      {isVideo ? (
        <video
          controls
          style={{
            width: width || '100%',
            height: height || 'auto',
            marginBottom: 20
          }}>
          <source src={filename} />
        </video>
      ) : (
        <img
          src={filename}
          alt={alt}
          style={{
            width: width || '100%',
            height: height || 'auto',
            marginBottom: 20
          }}
        />
      )}
    </>
  );
};

export default Media;
